// extracted by mini-css-extract-plugin
module.exports = {"mSizingGuide":"So","top":"To","sizeTable":"Uo"};